import * as XLSX from 'xlsx';

export const exportTableToExcel = ({
  tableId,
  filename = 'Table Export',
  worksheetName = 'tablexls',
}) => {
  const table = document.getElementById(tableId);
  if (!table) return;

  const workbook = XLSX.utils.table_to_book(table, { sheet: worksheetName });
  XLSX.writeFile(workbook, `${filename}.xls`);
};
